import React from 'react';
import './ProfileInfo.css';

const ProfileInfo = ({ user, profile, loading, error}) => {
  const userData = user 
  const profileData = profile  

  const getDisplayName = () => {
    return profileData?.name;
  };

  const getStatusClass = () => {
    switch (profileData?.status) {
      case 'REGISTERED':
      case 'VERIFYING':
        return 'profile-status registered';
      case 'VERIFIED':
      case 'ACTIVE':
        return 'profile-status active';
      case 'DELETED':
      case 'BLOCKED':
      case 'BANNED':
        return 'profile-status deleted';
      default:
        return 'profile-status';
    }
  };

  const getStatusName = () => {
    return profileData?.status
  };

  return (
    <div className="profile-header">
      <div className="profile-avatar">
        <div className="avatar-circle">
          {userData?.photo_url ? (
            <img src={userData.photo_url} alt="Avatar" className="avatar-image" />
          ) : (
            <span className="avatar-initials">{'👤'}</span>
          )}
        </div>
      </div>
      <p>ID: {userData?.id}</p>
      <h3>{getDisplayName()}</h3>
      {userData?.username && (
        <p className="username">@{userData?.username}</p>
      )}
      <div className={`${getStatusClass()} mt-2`}> {getStatusName()} </div>
    </div>
  );
};

export default ProfileInfo;